import { Channel, ChannelInfo } from '../types'

export const mapChannelDataFromAPI = (channelData: any) => {
  const envVariables = import.meta.env
  const linkPath = channelData.IsAdult
    ? `/private-mode`
    : `/player?channel=${channelData.FriendlyUrlName}`
  const channel: Channel = {
    id: channelData.Id,
    title: channelData.Title,
    isAdult: channelData.IsAdult,
    callLetter: channelData.CallLetter,
    availableOnChannels: channelData.AvailableOnChannels,
    thematic: channelData.Thematic,
    description: channelData.Description,
    MEOGo: {
      isAvailable: channelData.AvailableOnChannels.includes('PC'),
      link: envVariables.VITE_MEOGO_BASE_URL + linkPath,
    },
    logoUrl: `${envVariables.VITE_LOGO_URL}${
      channelData.CallLetter
    }&profile=corner_transparent_positive&width=60`,
    channelPosition: channelData.ChannelPosition,
    friendlyUrlName: channelData.FriendlyUrlName,
  }
  return channel
}

export const mapChannelInfoFromAPI = (channelData: any): ChannelInfo => {
  const envVariables = import.meta.env
  const linkPath = channelData.IsAdult
    ? `/private-mode`
    : `/player?channel=${channelData.FriendlyUrlName}`
  const channelInfo: ChannelInfo = {
    id: channelData.Id,
    title: channelData.Title,
    isAdult: channelData.IsAdult,
    callLetter: channelData.CallLetter,
    availableOnChannels: channelData.AvailableOnChannels,
    thematic: channelData.Thematic,
    channelPosition: channelData.ChannelPosition,
    friendlyUrlName: channelData.FriendlyUrlName,
    imageQuality: channelData.ImageQuality,
    isLiveAnyTime: channelData.IsLiveAnyTime,
    moreInfoUrl: channelData.MoreInfoUrl,
    MEOGo: {
      isAvailable: channelData.AvailableOnChannels.includes('PC'),
      link: envVariables.VITE_MEOGO_BASE_URL + linkPath,
    },
    logoUrl: `${envVariables.VITE_LOGO_URL}${
      channelData.CallLetter
    }&profile=corner_transparent_positive&width=60`,
  }
  return channelInfo
}

export const fetchChannels = async () => {
  const response = await fetch(
    `${
      import.meta.env.VITE_SERVICE_URL
    }/Services/GridTv/GridTv.svc/GetContentsForChannels?userAgent=IPTV_OFR_GTV`
  )
  if (!response.ok) throw new Error('Failed to fetch channels data')
  const json = await response.json()
  return json.Result.map((channelData: any) => {
    return mapChannelDataFromAPI(channelData)
  })
}
export const fetchChannelInfo = async (callLetter: string) => {
  const response = await fetch(
    `${
      import.meta.env.VITE_SERVICE_URL
    }/Services/GridTv/GridTv.svc/GetChannelInfo?callLetter=${callLetter}`
  )
  if (!response.ok) throw new Error('Failed to fetch channels data')
  const json = await response.json()
  return mapChannelInfoFromAPI(json.Result)
}
